import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

import { v4AccentButtonSx, v4GhostButtonSx } from '../../atoms/Button';

interface PartSummaryBarActionsProps {
  saving: boolean;
  canEdit: boolean;
  isDirty: boolean;
  onSave: () => void;
  onDiscard?: () => void;
}

export const PartSummaryBarActions: React.FC<PartSummaryBarActionsProps> = ({
  saving,
  canEdit,
  isDirty,
  onSave,
  onDiscard,
}) => {
  if (!canEdit) return null;

  return (
    <>
      {onDiscard && isDirty && !saving && (
        <Button
          variant="outlined"
          size="small"
          onClick={onDiscard}
          sx={v4GhostButtonSx}
          aria-label="Discard changes"
        >
          Discard
        </Button>
      )}
      <Button
        variant="contained"
        size="small"
        onClick={onSave}
        disabled={saving || !isDirty}
        sx={v4AccentButtonSx}
        startIcon={
          saving ? <CircularProgress size={12} sx={{ color: 'common.white' }} /> : undefined
        }
      >
        {saving ? 'Saving…' : 'Save'}
      </Button>
    </>
  );
};
